import { graphql } from 'gql';

export const priceListMtrRow = graphql(`
    query uerPriceListMtrRow($mtrRowId: Long!) {
        uerPriceListMtrRow(mtrRowId: $mtrRowId) {
            data {
                id
                code
                key
                name
                unit
                volume
                unitWeight
                unitCost
                supplyBy
                mtrType
                justification
                status
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updatePriceListMtrRow = graphql(`
    mutation uerUpdateMtrRow($chapter: ChapterEnum, $input: PriceListMtrRowUpdateInput!) {
        uerUpdateMtrRow(input: $input, chapter: $chapter) {
            result
            message
            hasValidation
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
